// extracted by mini-css-extract-plugin
export default {"promptPills":"dTjd9vf3P6xKkj0Bcjwg","promptBoxContainer":"xhmMuvMeD9lpgWcAa7q7"};